import {
  put, call, takeLatest, all, fork,
} from 'redux-saga/effects';
import { isFunction } from 'lodash';
import {
  FETCH_NOTIFICATIONS,
  ADD_NOTIFICATIONS,
  UPDATE_NOTIFICATIONS,
  DELETE_NOTIFICATIONS,
} from '../actions/notification/action_types';
import rf from '../../requests/RequestFactory';
import actions from '../actions/notification';
import utils from '../../common/utils';

function* fetchNotification(action) {
  try {
    const { data, total_count: totalCount } = yield call((params) => rf.getRequest('NotificationRequest').fetchNotification(params), action.params);
    yield put(actions.fetchNotificationSucceed(data, totalCount));
    if (isFunction(action.callback)) {
      yield action.callback(totalCount);
    }
  } catch (err) {
    yield put(actions.fetchNotificationFailed(err));
  }
}

function* addNotification(action) {
  console.log('123');
  try {
    yield call((params) => rf.getRequest('NotificationRequest').addNotification(params), action.params);
    if (isFunction(action.callback)) {
      yield action.callback();
    }
    utils.showNotification('Thông báo', 'Thêm thông báo thành công', 'success');
  } catch (err) {
    yield put(actions.addNotificationFailed(err));
  }
}

function* updateNotification(action) {
  try {
    yield call((params) => rf.getRequest('NotificationRequest').updateNotification(params), action.params);
    if (isFunction(action.callback)) {
      yield action.callback();
    }
    utils.showNotification('Thông báo', 'Sửa thông báo thành công', 'success');
  } catch (err) {
    yield put(actions.updateNotificationFailed(err));
  }
}

function* deleteNotification(action) {
  try {
    yield call((params) => rf.getRequest('NotificationRequest').deleteNotification(params), action.params);
    if (isFunction(action.callback)) {
      yield action.callback();
    }
    utils.showNotification('Thông báo', 'Xóa thông báo thành công', 'success');
  } catch (err) {
    yield put(actions.deleteNotificationFailed(err));
  }
}

function* watchNotification() {
  yield takeLatest(FETCH_NOTIFICATIONS, fetchNotification);
  yield takeLatest(ADD_NOTIFICATIONS, addNotification);
  yield takeLatest(UPDATE_NOTIFICATIONS, updateNotification);
  yield takeLatest(DELETE_NOTIFICATIONS, deleteNotification);
}

export default function* rootSaga() {
  yield all([fork(watchNotification)]);
}
